import React, { useState } from 'react';
import { createElement } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import './SocialShare.scss';

const SocialShare = (props) => {
  const { shareurl } = props;
  return (
    <div className="SocialShareMenu">
      <TwitterShareButton url={shareurl}>
        <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
          <use href="#twitter"></use>
        </svg>
      </TwitterShareButton>
      <FacebookShareButton url={shareurl}>
        <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
          <use href="#facebook"></use>
        </svg>
      </FacebookShareButton>
      <LinkedinShareButton url={shareurl}>
        <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
          <use href="#linkedin"></use>
        </svg>
      </LinkedinShareButton>
    </div>
  );
};

if (!customElements.get('social-share')) {
  customElements.define(
    'social-share',
    class extends HTMLElement {
      connectedCallback() {
        const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
        render(createElement(SocialShare, Object.fromEntries(props)), this);
      }
    }
  );
}
